import { Component, Input, OnInit } from "@angular/core";
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { merge, Subject } from "rxjs";

@Component({
  selector: "app-date-input",
  templateUrl: "./date-input.component.html",
  styleUrls: ["./date-input.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DateInputComponent,
      multi: true,
    },
  ],
})
export class DateInputComponent implements OnInit, ControlValueAccessor {
  constructor(public translate: TranslateService) {}

  date = new Subject<any>();

  years: number[] = [];
  months = Array.from({ length: 12 }, (_, i) => i + 1);
  days = Array.from({ length: 31 }, (_, i) => i + 1);

  dateForm: FormGroup;
  onChange: (value) => void;
  onTouched: () => void;
  disabled: boolean;
  @Input("center") center: boolean;

  ngOnInit(): void {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    let maxYear = yyyy - 18;
    while (maxYear > 1900) {
      this.years.push(maxYear);
      maxYear = maxYear - 1;
    }

    this.dateForm = new FormGroup({
      day: new FormControl(null, Validators.required),
      month: new FormControl(null, Validators.required),
      year: new FormControl(null, Validators.required),
    });
    this.date.subscribe((date) => {
      this.dateForm.get("year").setValue(date.year);
      this.dateForm.get("month").setValue(date.month);
      this.dateForm.get("day").setValue(date.day);
    });

    this.dateForm.valueChanges.subscribe((value) => {
      this.onChange && this.onChange(this.getDate(value));
    });
  }

  getDate(value): Date {
    if (!value.day || !value.month || !value.year) return null;
    const date = new Date(Date.UTC(value.year, value.month - 1, value.day));
    return this.isValidDate(date) ? date : null;
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
  }

  setValidation() {}

  writeValue(obj: string): void {
    if (obj != null) {
      const dateArray = obj.split("-");
      const date = {
        day: Number(dateArray[2]),
        month: Number(dateArray[1]),
        year: Number(dateArray[0]),
      };
      this.date.next(date);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = this.disabled;
  }
}
